export default {
    message: {
        'header': {
            'online': 'онлайн'
        },
        'footer': {
            'home': 'Дом',
            'points': 'Точка',
            'vip_zone': 'VIP-зона',
            'order': 'Заказ',
            'account': 'Счет'
        },
        'index': {
            'notice1': "Поздравляем игроков",
            'notice2': "'участвовать, выиграть",
            'notice3': "Поздравим его!",
            'hot_spot': 'ГОРЯЧАЯ ТОЧКА',
            'all_goods': 'Все товары',
            'promotion_type': 'Тип продвижения',
            'partners': 'Партнеры',
            'announcement': 'Объявление',
            'cancel': 'Отменить',
            'travel_to': 'TОтправиться в путешествие',
            'ok': 'OK'
        },
        'goods': {
            'name1': 'Двойной возврат',
            'name2': 'Наличные x2 возвращены',
            'name3': 'Возврат в 70 раз (VIP1)',
            'name4': 'Наличные x72 возвращено'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'Пожалуйста, выберите',
            'product_description': 'Описание продукта',
            'check_out': 'Проверить',
            'original_price': 'Первоначальная цена',
            'inventory': 'Запасы',
            'sold': 'Продажа',
            'tip_start': 'Успешное продвижение может быть преобразовано в ценный товар ',
            'tip_end': ' бесплатные монеты',
            'quantity': 'Количество',
            'total_price': 'общая цена',
            'win_rate': 'выигрыш',
            'predict_type': 'тип прогноза',
            'member_shared': 'участник получит сообщение',
            'share_now': 'Поделиться сейчас',
            'copy_the_link': 'Скопировать ссылку',
            'send_to_friend': 'Отправить другу',
            'copy_success': 'Успешное копирование',
            'copy_error': 'Ошибка копирования'
        },
        'integral': {
            'title': 'Область обмена интегралами',
            'search': 'Поиск информации о продукте',
            'points': 'Points'
        },
        'vip_zone': {
            'title': 'Список товаров VIP',
            'price': 'Цена',
            'sales_volume': 'Продажи'
        },
        'login': {
            'account_login': ['Вход в счет'],
            'login': 'Войти',
            'phone': 'Введите свой номер телефона',
            'pwd': 'Заполните пароль',
            'no_account': 'Есть ли существующий счет?',
            'forgot_password': 'забыл пароль',
            'register': 'Регистрация'
        },
        'reset_pwd': {
            'title': 'Получить пароль',
            'get_verification_code': 'Получить проверочный код',
            'confirm': 'Подтверждать',
            'verification_code': 'проверочный код',
            'your_new_pwd': 'Ваш новый пароль',
            'reload': 'Перезагрузка',
            'msg_phone': 'Пожалуйста, введите свой номер телефона'
        },
        'register': {
            'register_account': 'зарегистрировать счет',
            'account': 'Номер телефона',
            'pwd': 'Пароль для входа в систему',
            'con_pwd': 'Подтвердить пароль',
            'register': 'зарегистрировать',
            'tip_account': 'Есть ли существующий счет?',
            'by_click': 'Нажав на "зарегистрироваться", я согласился пойти в интересный торговый центр',
            'privacy_policy': 'Политика конфиденциальности',
            'tip_wrong': '* Неправильный номер телефона не сможет нормально использоваться',
            'msg_phone': 'Неверный формат телефона'
        },
        'order': {
            'submit_order': 'Отправить заказ',
            'item': 'пункт',
            'payment_method': 'Способ Оплаты',
            'pay_via_balance': 'оплата через баланс',
            'balance_available': 'доступный баланс',
            'total_price': 'общая цена',
            'total': 'Итого',
            'check_out': 'Проверить',
            'msg_param': 'Параметр неверен',
            'msg_order_field': 'Не удалось загрузить данные заказа',
            'msg_select_payment': 'Пожалуйста, выберите способ оплаты',
            'tip_create_order': 'Создание заказа....',
            'payment_succeeded': 'Платеж выполнен',
            'payment_fail': 'Ошибка платежа',
            'order_no': 'номер заказа',
            'order_time': 'Время заказа',
            'other': 'Другой',
            'total_amount': 'общая сумма',
            'failure_reason': 'Причина неудачи',
            'view_payment_results': 'Просмотр результатов платежа',
            'payment_failed_to_repay': 'Оплата не возмещена',
            'top_up': 'сверху вверх',
            'hot_spot': 'ГОРЯЧАЯ ТОЧКА',
            'back_home': 'Дома',
            'msg_create_success': 'Заказ был успешно создан',
            'confirm_title': 'Платить',
            'confirm_msg': 'Платеж не выполнен,',
            'confirm_cancel': 'Отменить',
            'confirm_top_up': 'сверху вверх',
            'game_odd': 'НЕЧЕТНОЕ',
            'game_even': 'ЧЕТНОЕ ',
            'game_title': 'НЕЧЕТНОЕ ИЛИ ЧЕТНОЕ',
            'game_select_title': 'Выберите ожидаемый результат',
            'game_odd_number': 'НЕЧЕТНОЕ',
            'game_even_number': 'ЧЕТНОЕ',
            'game_confirm_selection': 'Подтвердить выбор',
            'game_opening_time': 'Время включения',
            'game_issue': 'вопрос',
            'game_number': 'число',
            'game_results': 'результаты',
            'game_submit_err': 'Ошибка: НЕЧЕТНОЕ_id не существует!',
            'game_choose_least': 'Пожалуйста, выберите хотя бы один!',
            'game_success': 'успех',
            'game_error': 'Ошибка',
            'game_confirm': 'Подтверждение',
            'game_confirm_title': 'сообщение',
            'game_confirm_msg': 'Вы уверены, что хотите выбрать это? ',
            'game_confirm_cancel': 'Отменить',
            'chart': 'Графики',
            'close': 'Закрыть',
            'bulls_eye': 'Яблочко',
            'trend_recent': 'Тренд последних 50 периодов',
            'number': 'Число',
            'times_without': 'раз нет',
            'bet': 'Ставка'
        },
        'my_order': {
            'title': 'Мой заказ',
            'operated': 'эксплуатируемый',
            'receive': 'Получить',
            'completed': 'Готово',
            'converted': 'Преобразованный',
            'refund': 'Возврат',
            'item_total_amount': 'Пункт, сумма',
            'picking_up': 'Поднимите его',
            'redeem_points': ' точка спасения',
            'processing_pick_up': 'обработка для самовывоза',
            'hot_spot': 'ГОРЯЧАЯ ТОЧКА',
            'view_details': 'Посмотреть детали',
            'check_tracking': 'Проверка информации трассировки',
            'confirm_receival': 'Подтвердить получение',
            'receipt': 'Квитанция',
            'cancel': 'Отменить',
            'confirm_pick_up': 'Подтверждение доставки',
            'not_sales': 'еще не в продаже',
            'sales_failed': 'Продажа не удалась',
            'sales_success': 'Продажа удалась',
            'waiting_draw': 'В ожидании розыгрыша',
            'bonus_countdown': 'Бонусный обратный отсчет',
            'redeem_success': 'Успешные продажи',
            'awarded': 'Награжден',
            'points': 'точки',
            'fee': 'Платеж',
            'cash': 'Наличный',
            'sure': 'Конечно',
            'detail_title': 'Сведения о заказе',
            'detail_copy': 'копировать',
            'detail_order_no': 'номер заказа',
            'detail_order_time': 'Время заказа',
            'detail_type_order': 'Тип заказа',
            'detail_status_payment': 'статус платежа',
            'detail_have_pay': 'должен быть оплачен',
            'detail_did_pay': 'не оплачено',
            'detail_promotion_status': 'Статус акции',
            'detail_promotion_period': 'период акции',
            'detail_promotion_games': 'Продвижение игры',
            'detail_opening_time': 'Время открытия',
            'detail_my_choice': 'Мой выбор',
            'detail_lottery_numbers': 'номер лотереи',
            'detail_payment_method': 'способ оплаты',
            'detail_total_amount': 'Итого',
            'detail_amount_paid': 'Оплаченная сумма',
            'detail_re_order': 'Изменение порядка'
        },
        'user': {
            'account': 'Счет',
            'available_balance': 'Доступный баланс',
            'my_points': 'Мои точки',
            'active_code': 'код деятельности',
            'your_code': 'Введите код',
            'msg_code': 'Пожалуйста, заполните код обмена',
            'ok': 'OK',
            'deposit': 'Депозиты',
            'withdraw': 'Снять',
            'confirm_title': 'Подтвердить это изменение?',
            'confirm_msg': 'Изменение аватара',
            'confirm_cancel': 'Отменить',
            'confirm_ok': 'Подтвердить',
            'cancelled': 'Отмена',
            'profile_title': 'профиль пользователя',
            'profile_manage_account': 'Управление моим счетом',
            'profile_nickname': 'Ник-имя',
            'profile_real_name': 'настоящее имя',
            'profile_email': 'Email',
            'profile_phone': 'телефон',
            'profile_password': 'пароль',
            'profile_click_change_password': 'Нажмите, чтобы изменить пароль',
            'profile_save_the_change': 'Сохранить изменения',
            'profile_log_out': 'Выход из системы',
            'profile_confirm_title': 'Выход из системы',
            'profile_confirm_msg': 'Вы подтвердили выход?',
            'profile_confirm_cancel': 'Отменить',
            'profile_confirm': 'Подтвердить',
            'change_password_title': 'Изменить пароль',
            'change_password_current_pwd': 'Введите свой текущий пароль',
            'change_password_set_new_pwd': 'Установить новый пароль',
            'change_password_confirm_new_pwd': 'Подтвердить новый пароль',
            'change_password_confirm_change': 'Подтвердить изменение',
            'change_password_msg_current_pwd': 'Пожалуйста, введите текущий пароль, который вы используете',
            'change_password_msg_new_pwd': 'Пожалуйста, введите новый пароль',
            'change_password_msg_new_pwd_again': 'Пожалуйста, введите новый пароль снова',
            'change_password_msg_not_match': 'Пароль не совпадает',
            'user_rank_title': 'Запись об открытии награды',
            'user_menu_bulletin': 'объявление',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'обязательный платеж',
            'user_menu_agent': 'Агент',
            'user_menu_balance_details': 'Детали баланса',
            'user_menu_lottery_record': 'Запись лотереи',
            'user_menu_service': 'Услуга',
            'user_menu_about_us': 'О нас'
        },
        'balance_detail': {
            'title': 'Детали баланса',
            'total_amount': 'Итого',
            'top_up': 'сверху вверх',
            'accumulated_withdrawal': 'Накопленный выход (снятие)',
            'bill_record': 'Биллинговая запись',
            'consumption_records': 'Запись о потреблении',
            'recharge_records': 'запись о пополнении',
            'points_center': 'Центр точки',
            'sign_in': 'Войдите в систему, чтобы собрать очки (точки)',
            'upgrade_level': 'Обновить уровень, чтобы разблокировать больше игр!'
        },
        'my_pay': {
            'title': 'Связанный электронный кошелек',
            'phone': 'Телефон',
            'phone_plac': 'Введите свой телефон',
            'binance_id': 'ID валюты',
            'binance_id_plac': 'Введите ID валюты',
            'pay_nickname': 'платный псевдоним',
            'pay_id': 'ID платежа',
            'pay_id_plac': 'Введите ID платежа',
            'tip': 'Убедитесь, что вся информация верна, иначе вы не сможете выйти. ',
            'bind': 'Связывать',
            'edit': 'Редактировать',
            'msg_nickname': 'Пожалуйста, введите псевдоним платежа',
            'confirm_msg': "<b style='color: red'>Примечание </b>: Платежный псевдоним может быть изменен только один раз!!!<br>псевдоним оплаты::",
            'confirm_title': 'Редактирование псевдонима платежа',
            'confirm_cancel': 'Отменить',
            'confirm_cancelled': 'Отмена',
            'confirm_confirm': 'Подвердить',
            'msg_phone': 'Пожалуйста, введите номер телефона',
            'msg_binance_id': 'Пожалуйста, введите ID валюты',
            'msg_binance_id_format': 'Неверный формат ID валюты',
            'msg_pay_nickname': 'Пожалуйста, введите псевдоним платежа',
            'msg_pay_id': 'Пожалуйста, введите ID платежа',
            'msg_pay_id_format': 'Неверный формат ID платежа',
            'msg_pay_id_length': 'Ошибка в длине ID платежа',
            'msg_binance_pay': 'ID валюты не является ID платежа, его можно найти на странице получения.',
            'msg_confirm_title': 'Установка информации о подтверждении платежа',
            'msg_confirm_msg1': 'Ваш псевдоним оплаты',
            'msg_confirm_msg2': 'Ваш ID платеж',
            'msg_confirm_msg3': 'Примечание: после подтверждения он не может быть развязан!',
            'msg_confirm_cancel': 'Отменить',
            'msg_confirm_cancelled': 'Отмено',
            'msg_confirm': 'Подтвердить',
            'bind_success_msg': 'Ссылка успешна, и удалось'
        },
        'user_bill': {
            'title': 'Детали баланса',
            'all': 'Все',
            'consumption': 'Потребление',
            'recharge': 'Перепополнение',
            'income': 'Доход'
        },
        'user_integral': {
            'title': 'Детали точки',
            'current_points': 'Поток точки',
            'accumulated_points': 'Накопленные точки',
            'accumulated_consumption': 'Совокупное потребление',
            'obtained_today': 'Получено сегодня',
            'details_points': 'Детали точки',
            'increase_points': 'увеличение точки',
            'points_rewarded_purchasing': 'бонусные точки за покупку',
            'earn_points': 'заработать точки',
            'points_rewarded_sign': 'Награды за каждый день за регистрацию',
            'sign_points': 'Точки',
            'sign_details': 'Детали',
            'sign_signed': 'Вход',
            'sign_sign': 'Вход',
            'sign_accumulated_sign': 'Накопленный вход',
            'sign_days': 'Дни',
            'sign_tip2_s': 'Говорят, что',
            'sign_tip2_e': ' Непрерывные дни входа в систему получат огромное вознаграждение, не забудьте войти в систему ~~~',
            'sign_click_load_more': 'Щелкните для загрузки дополнительной информации',
            'sign_success': 'Успешный вход в систему',
            'sign_awarded': 'Награжден',
            'sign_sure': 'Да',
            'sign_cnum': ["ноль", " один", "два", " три", "четыре", " пять", "шесть", " семь", "восемь", " девять"],
            'sign_msg_signed': 'Вы записались сегодня!',
            'detail_title': 'Заказ очков',
            'detail_phone': 'телефон',
            'detail_payment_method': 'способ оплаты',
            'detail_pay_with_points': 'Оплата точками',
            'detail_available_points': 'Доступные точки',
            'detail_total': 'Итого',
            'detail_points': 'точки',
            'detail_check_out': 'Проверить',
            'pay_points': 'Оплатить точки',
            'detail_parameter_wrong': 'Параметр неверен',
            'detail_failed_data': 'Не удалось загрузить данные заказа',
            'detail_creating_order': 'Создается заказ...',
            'detail_creating_order_fail': 'Не удалось создать заказ',
            'detail_status_title': 'Успешный обмен товарами',
            'detail_status_check_mailbox': 'Пожалуйста, проверьте ваш почтовый ящик, мы доставим товар в течение 24 часов',
            'detail_status_view_order': 'Просмотреть заказ',
            'detail_status_back_home': 'Домой',
            'detail_points_title': 'Детали точки',
            'my_order_points_title': 'Мой заказ точки'
        },
        'recharge': {
            'title': 'Представление заявки на пополнение счета',
            'first_deposit': 'бонус за первый вклад',
            'use_binance': 'Использовать Binance',
            'choose_amount': 'Пожалуйста, выберите сумму и продолжите',
            'current_balance': 'Примечание: текущий баланс',
            'confirm_top_up': 'Подтверждение пополнения',
            'application_details': 'Сведения о приложении пополнения',
            'order_number': 'номер заказа',
            'application_time': 'Время подачи заявки',
            'top_up_amount': 'Сумма пополнения',
            'top_up_status': 'Состояние пополнения',
            'reviewing': 'Комментарий',
            'application_success': 'заявка удалась',
            'application_failed': 'заявка не удалась',
            'msg_bind_binance': 'Пожалуйста, свяжите привязку платежа',
            'msg_minimum_bank': 'минимум 100 может быть пополнено',
            'msg_minimum_binance': 'минимум 1 до пополнения',
            'msg_enter_top_up_amount': 'Пожалуйста, введите сумму пополнения',
            'confirm_title': 'Подтверждение сведений о вкладе',
            'confirm_verify_information': 'Пожалуйста, проверьте эту информацию',
            'confirm_tip': 'Отправьте деньги на любой из следующих счетов с помощью связанных платежей, щелкните в правом верхнем углу, чтобы увидеть учебник.',
            'confirm_our_pay_id': 'ID нашей оплаты',
            'confirm_copy': 'копировать',
            'confirm_top_up_amount': 'Сумма пополнения',
            'confirm_confirm_top_up': 'Подтверждение пополнения',
            'confirm_msg_copy': 'Успешное копирование',
            'confirm_msg_enter_amount': 'Пожалуйста, введите сумму для пополнения',
            'confirm_transfer_amount': 'сумма перевода не менее 1',
            'confirm_alert_mes': "Пожалуйста, подтвердите, что он был использован для оплаты залога. < bстиль=\ 'Цвет: красный \' > Пожалуйста, подождите 5-10 минут, чтобы прибыть. </b> Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь со службой поддержки вовремя.",
            'confirm_alert_title': 'Подать заявку на пополнение счета',
            'confirm_alert_cancel': 'Отменить',
            'confirm_alert_msg_cancelled': 'Отмено',
            'confirm_alert_confirm': 'Подтвердить'
        },
        'withdrawal': {
            'title': 'Снятие',
            'link_now_tip': 'Вы еще не сделали ссылку на свой электронный кошелек, пожалуйста, сделайте ссылку еще раз и отправьте заявку на снятие.',
            'link_now': 'Связать сейчас',
            'withdrawal_account': 'Счет снятия',
            'phone': 'Телефон',
            'binance_id': 'ID валюты Binance ',
            'nickname': 'пик-имя',
            'pay_id': 'ID платежа',
            'withdraw_amount': 'Счет снятия',
            'balance': 'Баланс',
            'processing_fee': 'Сборы',
            'actual_amount': 'фактическая сумма',
            'msg_withdrawal_account': 'Пожалуйста, выберите счет снятия',
            'msg_fill_data': 'Пожалуйста, заполните данные',
            'msg_phone': 'Пожалуйста, введите номер телефона',
            'msg_binance_id': 'Пожалуйста, введите ID Binance ',
            'msg_binance_pay_id': 'Пожалуйста, введите ID платежа Binance',
            'msg_pay_id_err': 'Неверный формат ID платежа',
            'msg_withdraw_amount': 'Пожалуйста, введите сумму снятия',
            'msg_insufficient_balance': 'Недостаточный баланс',
            'msg_mini_withdraw': 'Минимум 160 для снятия',
            'msg_minimum': 'Минимум',
            'msg_to_withdraw': 'снять',
            'audit_tip': 'Снятие представлено, ожидать рассмотрение',
            'audit_sure': 'Да'
        },
        'user_vip': {
            'title': 'Центр членов',
            'able_purchase': 'Можно приобрести товар в',
            'off': 'Закрыть',
            'level_task1': 'Заполните 1 долларовый депозит и приобретите товар 50 раз, чтобы стать VIP!',
            'level_task2': 'Плата за снятие',
            'level_task3': 'Время снятия',
            'level_task4': 'H',
            'vip_level_unlocked': 'VIP-уровень разблокирован',
            'higher_level_unlocked': 'высший уровень разблокирован',
            'vip_upgrade_requirements': 'Требования к обновлению VIP',
            'required_tasks': 'обязательные задания',
            'select_one_below': 'Пожалуйста, выберите одно из ниже',
            'achieved': 'достигнуто',
            'conditions_met': 'условие не выполнено',
            'accumulated_participation': 'Совокупное участие в играх',
            'achieved_top_up': '50 монет с совокупным пополнением',
            'exclusive_coupons': 'эксклюзивный купон',
            'more_games': 'Больше игр',
            'need_recharge': 'нужно пополнить 50 монет'
        },
        'promoter': {
            'title': 'Управление промоутером',
            'apply_agency': 'Подать заявку в агентство и стать одним из нас',
            'become_agent': 'Стать агентом',
            'repeatedly_delayed': 'Загрузка может быть отложена, пожалуйста, подождите, не нажимайте много!',
            'current_commission': 'Текущий комитет',
            'record': 'Запись',
            'profit_yesterday': 'вчерашняя прибыль',
            'accumulated_withdrawal': 'Накопленный выход',
            'withdraw': 'Снятие',
            'refer_friends': 'Пригласить друзей',
            'total_agent': 'Всего агента',
            'copy_success': 'Успешное копирование',
            'copy_error': 'Ошибка копирования',
            'promoter_achievements': 'Достижения промоутеров',
            'promoter_orders': 'Заказ промоутера',
            'promoter_ranking': 'Рейтинг спонсоров',
            'commission_ranking': 'рейтинг комитета',
            'list_title': 'Количество агентов',
            'list_number_agents': 'Количество агентов',
            'list_people': 'Человек',
            'list_date_joined': 'дата присоединения',
            'list_item': 'Пункт',
            'order_title': 'Накопленный заказ',
            'order_accumulated_orders': 'Накопленный заказ',
            'order_commission': 'Комиссия',
            'order_time': 'Время заказа',
            'order_mark': 'отметка',
            'commission_title': 'Достижения промоутеров',
            'commission_accumulated_commission': 'Накопленная комиссия',
            'commission_available': 'Комиссия доступна для снятия',
            'commission_week': 'Новые участники в этой неделе',
            'commission_month': 'Новые участники в этом месяце',
            'commission_achievement': 'Достижения',
            'commission_rank_title': 'Commission ranking',
            'commission_rank_current': 'Рейтинг комитетаg',
            'commission_rank_yet': 'Ваш текущий рейтинг',
            'rank_title': 'Вы еще не вошли в стадию ранжирования',
            'cash_record_title': 'Детали снятия комиссии',
            'cash_record_cash_out': 'Запись о выплате',
            'user_cash_title': 'Снятие комиссии',
            'user_cash_not_link': 'У вас еще нет привязки электронного кошелька, пожалуйста, установите ссылку и снова отправьте заявку на снятие средств.',
            'user_cash_link_now': 'Связать сейчас',
            'user_cash_service_provider': 'поставщик услуг',
            'user_cash_select_account': 'Пожалуйста, выберите счет для снятия',
            'user_cash_binance_pay': 'Binance Платеж',
            'user_cash_bank_account': 'Счет банка',
            'user_cash_bank_account_pla': 'Пожалуйста, заполните номер вашего банковского счета',
            'user_cash_ifsc_pla': 'Пожалуйста, заполните свой аккаунт IFSC',
            'user_cash_upi_pla': 'Пожалуйста, заполните свой аккаунт в UPI',
            'user_cash_withdraw': 'Снятие',
            'user_cash_minimum': 'Минимум',
            'user_cash_to_withdraw': 'Снять',
            'user_cash_current_commission': 'Текущая комиссия доступна для снятия',
            'user_cash_account': 'Счет',
            'user_cash_account_pla': 'Пожалуйста, укажите ваше платное имя пользователя',
            'user_cash_current_withdrawal': 'Текущий комитет по снятию',
            'user_cash_to_e_wallet': 'снять в электронный бумажник',
            'user_cash_to_balance': 'снять в баланс',
            'user_cash_insufficient_balance': 'Недостаточный баланс',
            'user_cash_data_format': 'Ошибка формата данных'
        },
        'service': {
            'title': 'Запись сообщений',
            'write_email': 'Пожалуйста, напишите нам по электронной почте'
        }
    }
};